export type WebBillingCurrency = "brl" | "usd";

export const WEB_PLAN_PRICES: Record<
  WebBillingCurrency,
  { weekly: number; monthly: number }
> = {
  brl: { weekly: 11.99, monthly: 34.99 },
  usd: { weekly: 4.99, monthly: 12.99 },
};

export function getBrowserCurrencyOverride(): string | undefined {
  if (typeof navigator === "undefined") return undefined;

  const language = navigator.language?.toLowerCase();
  if (language === "pt-br" || language?.startsWith("pt-br-")) return "BRL";

  return undefined;
}

export function getBrowserBillingCurrency(): WebBillingCurrency {
  return getBrowserCurrencyOverride() === "BRL" ? "brl" : "usd";
}

export function getLocalPriceFallback(
  amount: number,
  currency: WebBillingCurrency = getBrowserBillingCurrency(),
): string {
  const locale =
    typeof navigator !== "undefined" ? navigator.language : "en-US";

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency.toUpperCase(),
  }).format(amount);
}
